import createPermission from 'permissions/createPermission'

import list from './list'

export const remove = createPermission('units.basicConfig.remove')

export default createPermission(
    list,
    remove,
)